import appConstants from '../../../../appConstants';
import { formatDate, formatDateTime, formatESTDateTime } from '@dataGrid/gridUtilities';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration();
  }

  static actionValueGetter(params) {
    const { changedBy } = params.data;
    const actions = Object.keys(appConstants.ACTION);
    if (actions.includes(changedBy)) {
      return appConstants.ACTION[changedBy];
    }
    return changedBy;
  }

  static userValueGetter(params) {
    const { firstName, lastName, user } = params.data;

    if (firstName && lastName && firstName.toLowerCase() !== 'admin') {
      return firstName + ' ' + lastName;
    } else if (user) {
      return user.toLowerCase() === 'etl' ? 'RouteMAX' : user;
    }
    return '';
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ProHistory,
      keyColumn: 'proId',
      defaultColDef: {
        resizable: false
      },
      columns: [
        {
          headerName: 'Plan Date',
          field: 'planDate',
          minWidth: appConstants.columnWidth.W_100,
          valueFormatter: formatDate
        },
        {
          headerName: 'Terminal',
          field: 'terminalCode',
          minWidth: appConstants.columnWidth.TERMINAL
        },
        {
          headerName: 'Action',
          field: 'changedBy',
          tooltipValueGetter: GridConfig.actionValueGetter,
          minWidth: appConstants.columnWidth.REPORTS_PRO_CHANGED_BY,
          valueGetter: GridConfig.actionValueGetter
        },
        {
          headerName: 'Route',
          field: 'routeName',
          minWidth: appConstants.columnWidth.ROUTES,
          suppressSizeToFit: true
        },
        {
          headerName: 'Route Type',
          field: 'routeType',
          minWidth: appConstants.columnWidth.TOTAL_STOPS
        },
        {
          headerName: 'Shipment Status',
          field: 'shipmentStatus',
          tooltipField: 'shipmentStatus',
          minWidth: appConstants.columnWidth.SHIPMENT_STATUS
        },
        {
          headerName: 'User',
          field: 'user',
          tooltipValueGetter: GridConfig.userValueGetter,
          minWidth: appConstants.columnWidth.REPORTS_USER,
          valueGetter: GridConfig.userValueGetter
        },
        {
          headerName: 'Trailer#',
          headerTooltip: 'Trailer Number',
          field: 'trailerNumber',
          minWidth: appConstants.columnWidth.W_140
        },
        {
          headerName: 'IB ETA',
          headerTooltip: 'Inbound Arrival Time',
          field: 'inboundArrivalTime',
          minWidth: appConstants.columnWidth.IBETA,
          valueFormatter: formatDateTime
        },
        {
          headerName: 'Apt Window',
          headerTooltip: 'Appointment Window',
          field: 'aptWindow',
          minWidth: appConstants.columnWidth.EARLY_LATE_CTA
        },
        {
          headerName: 'PSE',
          headerTooltip: 'Pallet Space Equivalent',
          field: 'pse',
          minWidth: appConstants.columnWidth.PSE
        },
        {
          headerName: 'LG',
          headerTooltip: 'Lift Gate',
          field: 'isLiftGate',
          minWidth: appConstants.columnWidth.LG
        },
        {
          headerName: 'Timestamp (EST)',
          field: 'createdDateTime',
          minWidth: appConstants.columnWidth.W_150,
          valueGetter: (params) => formatESTDateTime({ value: params.data.createdDateTime })
        }
      ]
    };
  }
}
